import { useEffect, useState } from 'react';
import { getRoleDashboardSummary } from 'Pages/User/service/index.Service';
import RolesCard from 'Components/Card/RolesCard';
import { Icon } from 'Components';
import { useTranslation } from 'react-i18next';
interface Props {
    tenantId?: string | number;
    refreshKey: number;
}

interface RoleDashboardSummary {
	primaryRolesCount: number;
	customRolesCount: number;
	usersCount: number;
}

const RolesCardDashboard = ({ tenantId , refreshKey }: Props) => {
	
	const { t } = useTranslation();

	const [data, setData] = useState<RoleDashboardSummary>({
		primaryRolesCount: 0,
		customRolesCount: 0,
		usersCount: 0
	});

	useEffect(() => {
		const fetchDashboard = async () => {
			try {
				const response = await getRoleDashboardSummary(tenantId);
				setData(response);
			} catch (error) {
				console.error('Failed to fetch role dashboard summary', error);
			}
		};

		fetchDashboard();
	}, [tenantId, refreshKey]);
	
	const cards = [
		{
			icon: <Icon type='table' />,
			label: t('roles.dashboard.totalRoles'),
			value: (data.primaryRolesCount ?? 0) + (data.customRolesCount ?? 0),
			tooltip: t('roles.dashboard.totalRolesTooltip'),
			valueColor: 'blue' as const
		},
		{
			icon: <Icon type='gear' />,
			label: t('roles.dashboard.primaryRoles'),
			value: data.primaryRolesCount,
			tooltip: t('roles.dashboard.primaryRolesTooltip'),
			valueColor: 'blue' as const
		},
		{
			icon: <Icon type='settingsIcon' />,
			label: t('roles.dashboard.customRoles'),
			value: data.customRolesCount,
			tooltip: t('roles.dashboard.customRolesTooltip'),
			valueColor: 'blue' as const
		},
		{
			icon: <Icon type='multiusers' />,
			label: t('roles.dashboard.totalUsers'),
			value: data.usersCount,
			tooltip: t('roles.dashboard.totalUsersTooltip'),
			valueColor: 'blue' as const
		}
	];

	return (
		<div className="roles-card-dashboard">
			{cards.map((card) => (
				<RolesCard
					key={card.label}
					{...card}
				/>
			))}
		</div>
	);
};

export default RolesCardDashboard;